// ======================================================================
// File Name       : ContentQuestionAttributeBulkRegistration
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { FormControl, Col, Button, Table, Form } from 'react-bootstrap';
import FileUpload from '../../components/FileUpload';

class ContentQuestionAttributeBulkRegistration extends React.Component {
  render() {
    const {
      bulkFileName,
      handleBulkFileChange,
      cancelBulkRegistration,
      bulkRegistration,
    } = this.props;
    return (
      <div>
        <p className="margin-top-10 padding-left-15">一括で投入する問題属性情報ファイルを指定してください</p>
        <Form.Group>
          <Col
            sm={{
              span: 11,
              offset: 1
            }}
            className="margin-top-10">
            <FileUpload
              labelName="ファイル選択"
              inputId={'bulkFileUploadBtn'}
              onChange={handleBulkFileChange}
              fileName={bulkFileName}
              accept="application/zip"
            />
          </Col>

          <Col
            sm={{
              span: 11,
              offset: 1
            }}
            as={Form.Label}
            className="margin-top-5">
            {bulkFileName ? `${'ファイル名：'}${bulkFileName}` : <br />}
          </Col>
        </Form.Group>
        <Form.Group className="margin-top-50 text-center">
          <Col sm={12}>
            <Button variant="default" className="btn-96 margin-10" onClick={cancelBulkRegistration}>
              キャンセル
            </Button>
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={bulkRegistration}
              disabled={!bulkFileName}
            >
              OK
            </Button>
          </Col>
        </Form.Group>
      </div>
    );
  }
}
export default ContentQuestionAttributeBulkRegistration;
